import { Option } from '../../types/common/option';

const listingTypes:Option[] = [
    {
        label: "Sale",
        value: "sale",
        order: 1
    },
    {
        label: "Lease",
        value: "lease",
        order: 2
    },
    {
        label: "Sale/Lease",
        value: "salelease",
        order: 3
    }
];

export default listingTypes;